import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface BookingSettings {
  buffer_before: number; // minutes before booking to block
  buffer_after: number;  // minutes after booking to block
  allow_same_day: boolean;
  min_advance_hours: number; // minimum hours in advance for same-day
}

const defaultSettings: BookingSettings = {
  buffer_before: 0,
  buffer_after: 0,
  allow_same_day: false,
  min_advance_hours: 3,
};

export const useBookingSettings = () => {
  const [settings, setSettings] = useState<BookingSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("app_settings")
      .select("value")
      .eq("key", "booking_settings")
      .maybeSingle()
      .then(({ data }) => {
        if (data?.value && typeof data.value === "object") {
          setSettings({ ...defaultSettings, ...(data.value as Record<string, any>) });
        }
        setLoading(false);
      });
  }, []);

  return { settings, loading };
};
